import { j as s } from "./utils-BdNIfrGQ.js";
import { I as m } from "./Image-Ct1HaCUq.js";
const l = ({
  loading: r = "eager",
  fetchPriority: a = "high",
  ...e
}) => /* @__PURE__ */ s.jsx(m, { className: "h-full w-full", ...e, loading: r, fetchPriority: a });
export {
  l as B
};
